'use strict';
/* eslint no-sync: 0 */

import angular from 'angular';

export class NavbarComponent {

    constructor(Auth) {
        'ngInject';
        this.isLoggedIn = Auth.isLoggedInSync;
        this.getCurrentUser = Auth.getCurrentUserSync;
    }
}

export default angular.module('directives.navbar', [])
    .component('navbar', {
        template: require('./navbar.html'),
        controller: NavbarComponent
    })
    .name;



// WEBPACK FOOTER //
// ./client/components/navbar/navbar.component.js